 function handleLightbox(evt) {
  const _s = {
    
    slideClickedIndex: () => evt.target.dataset.slideIndex,
    parent: () => evt.target.closest('.gdc-slider-image-lightbox'),
    lightbox: () => _s.parent().querySelector('.gdc-slider-image-lightbox__lightbox'),
    lightboxSlides: () => _s.lightbox().querySelectorAll('.gdc-slider-image-lightbox__lightbox-slide'),
    slideCount: () => _s.lightboxSlides().length,
    freezeBackground: () => document.body.style.overflow = "hidden",
    unfreezeBackground: () => document.body.style.overflow = "visible",
    deactivateAllSlides: () => _s.lightboxSlides().forEach(slide => slide.classList.remove('gdc-active')),
    lightboxArrows: () => document.querySelectorAll('.lightbox--arrow'),
    closeLightBox: () => _s.lightbox().classList.add('gdc-hidden'),
    currentActiveSlide: () => _s.parent().querySelector('.gdc-slider-image-lightbox__lightbox-slide.gdc-active'),
    currentActiveSlideIndex: () => parseInt(_s.currentActiveSlide().dataset.slideIndex),


    activateClickedSlide: () => [ ..._s.lightboxSlides() ]
                                      .filter(slide => slide.dataset.slideIndex === _s.slideClickedIndex())[0]
                                      .classList.add('gdc-active'),

    setActiveSlide: (idx) => {
      const nextSlide = _s.parent()
                          .querySelector(`.gdc-slider-image-lightbox__lightbox-slide[data-slide-index="${setIndex()}"]`)

      function setIndex() {
        let i = idx

        if (idx < 1)  i = _s.slideCount()
        if (idx > _s.slideCount()) i = 1

        return i
      }

      if (nextSlide) {
        _s.deactivateAllSlides();
        nextSlide.classList.add('gdc-active')
      }

    },
    
    handleChangeSlide: (e) => {
      const direction = e.target.dataset.direction 

      direction === 'right'
        ? _s.setActiveSlide(_s.currentActiveSlideIndex() + 1)
        : _s.setActiveSlide(_s.currentActiveSlideIndex() - 1)
    },

    handleSliderArrows: () => {
      _s.lightboxArrows().forEach(arrow => {
        arrow.addEventListener('click', _s.handleChangeSlide) 
      })
    },

    handleClose: (e) => {  
      const insideSlide = e.target.closest('.gdc-slider-image-lightbox__lightbox-slide')
      const insideButton = e.target.classList.contains('gdc-slider-image-lightbox__slider-controls-arrow')

      if (!insideSlide && !insideButton) {
        _s.closeLightBox()
        _s.unfreezeBackground()
      }
    },

    handleOpen: () => {
      _s.lightbox().classList.remove('gdc-hidden')
      _s.deactivateAllSlides()
      _s.activateClickedSlide()
      _s.freezeBackground()
      _s.lightbox().addEventListener('click', _s.handleClose),
      _s.handleSliderArrows()
    }
  }

  _s.handleOpen()

 }

  // =========================================================== //
// ===================== SLIDER CLONES ======================= //
// =========================================================== //

function setSliderClones() {
  const sliders = document.querySelectorAll('.gdc-slider-image-lightbox')

  sliders.forEach(slider => {
    const slidesContainer = slider.querySelector('.gdc-slider-image-lightbox__slider')
    const slides = slider.querySelectorAll('.gdc-slider-image-lightbox__slide')

    slides.forEach((slide, i) => {
      
      let clone = slide.cloneNode(true)
      clone.setAttribute('clone', i)
      slidesContainer.appendChild(clone)

    })

  })
}

window.addEventListener('DOMContentLoaded', setSliderClones)
 
 // =========================================================== //
// ===================== SLIDER BUTTONS ======================= //
// =========================================================== //

 function handleSlider(evt, offset) {
    const _s = {

      slider: () => evt.target
                    .closest('.gdc-slider-image-lightbox')
                    .querySelector('.gdc-slider-image-lightbox__slider'),
      originalSlides: () => _s.slider().querySelectorAll('.gdc-slider-image-lightbox__slide:not([clone])'),
      sliderScrollPosition: () => _s.slider().scrollLeft,
      numberOfOriginalSlides: () => _s.originalSlides().length,
      slideWidth: () => _s.originalSlides()[0].offsetWidth,
      totalWidthOriginalSlides: () => (offset * _s.numberOfOriginalSlides()) 
                                    + (_s.slideWidth() * _s.numberOfOriginalSlides()),
      slideAmount: () => window.innerWidth + offset,   
      direction: () => evt.target.dataset.direction,
      firstClone: () => _s.slider().querySelector('[clone="0"]'),
      handleScroll: () => _s.direction() === 'left' ? _s.scrollLeft() : _s.scrollRight(),
      scrollRight: () => _s.slider().scrollBy({left: _s.slideAmount(), behavior: 'smooth'}),

      scrollLeft: () => {
        if (_s.sliderScrollPosition() === 0) {
          _s.slider().scrollLeft = _s.totalWidthOriginalSlides()
          _s.slider().scrollBy({left: -_s.slideAmount(), behavior: 'smooth'})
        } else {
          _s.slider().scrollBy({left: -_s.slideAmount(), behavior: 'smooth'})
        }
      }
    }

    _s.handleScroll()
 }

  // =========================================================== //
 // ==================== HANDLES RIGHT CLICK LOOPING ========== //
// =========================================================== //


 function handleRightLooping() {
  const _s = {
     slider: () => document.querySelector('.gdc-slider-image-lightbox__slider'),
     firstClone: () => _s.slider().querySelector('[clone="0"]'),
     sliderLoopRight: () => {
        if (_s.firstClone().getBoundingClientRect().left < 0) _s.slider().scrollLeft = 0
      }
  }

  _s.slider().addEventListener('scroll', _s.sliderLoopRight)
}

window.addEventListener('DOMContentLoaded', handleRightLooping)










